import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ChangeDetectorRef, ElementRef } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import {TranslateService} from '@ngx-translate/core';
import { SurveyStatusV2Service } from "../../survey-status-v2.service";
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { DATOS_API } from 'app/auth/auth.datos';
import * as _ from 'lodash';
import { MatSnackBar } from "@angular/material/snack-bar";

import { SurveyCheckComponent } from "./survey-check/survey-check.component";
import {DescargaEncuestaComponent} from 'app/main/pagina/tools/gestUsu/detail/descarga-encuesta/descarga-encuesta.component';
import { ModalComponent as ModalComponentAcciones} from "./modal/modal.component";
import { ModalComponent as ModalComponentLogMail} from "app/main/pagina/tools/survey-status-v2/contenido/log-emails/modal/modal.component";
import { LyDialog } from '@alyle/ui/dialog';
import { CloudService } from 'app/main/pagina/tools/cloud/cloud.service';
import { ModalImgComponent } from "app/main/pagina/productos/certificar/tipo_2/editor-encuesta/modal-img/modal-img.component";
import { ModalRecoComponent } from "app/main/pagina/productos/certificar/tipo_2/crear-encuesta/vista-gen/modal-reco/modal-reco.component";
import { ModalCompProfileComponent } from "app/main/pagina/web-comp-profile/modal-comp-profile/modal-comp-profile.component";
import { WebCompProfileService } from 'app/main/pagina/web-comp-profile/web-comp-profile.service';
import { ConfigResultComponent } from "app/main/pagina/tools/gestUsu/detail/config-result/config-result.component";
const moment = require('moment');
const momentTz = require('moment-timezone');

// const accionActiva = (accion) => accion.activa == true;

@Component({
  selector: 'acciones',
  templateUrl: './acciones.component.html',
  styleUrls: ['./acciones.component.scss'],
  animations   : fuseAnimations
})
export class AccionesComponent implements OnInit {

  @Input() setStatusBoton: Observable<any>;
  @Input() infoSurveyCheck: Observable<any>;
  @Input() infoEmpresaProducto: Observable<any>;

  @Output() actualizarStatusEncuesta: EventEmitter<any> = new EventEmitter();
  @Output() verResultadosIframe: EventEmitter<any> = new EventEmitter();
  @Output() actualizarRecordatorios: EventEmitter<boolean> = new EventEmitter();
  @Output() actualizarAvisos: EventEmitter<boolean> = new EventEmitter();
  @Output() actualizarProrroga: EventEmitter<any> = new EventEmitter();
  @Output() actualizarFechIniCie: EventEmitter<any> = new EventEmitter();

  @ViewChild('fechaGenerica') calendarioProrroga: any;
  @ViewChild('imagen') logoCertificado: ElementRef<HTMLElement>;
  @ViewChild('logoEmpresa') logoEmpresa: ElementRef<HTMLElement>;
  categorias = [
    {
      nombre: 'Encuesta',
      id: 'encuesta',
      visible: true,
      acciones: [
        { id: 'surveyCheck', nombre: 'Comprobación de la encuesta', icono: 'check_circle', bloqueado: true, funcion: 'surveyCheck', visible: true },
        { id: 'surveyDown', nombre: 'Descargar encuesta', icono: 'arrow_downward', bloqueado: true, funcion: 'descargarEncuesta', visible: true },
        { id: 'goSurvey', nombre: 'Ir a la encuesta', icono: 'send', bloqueado: true, funcion: 'irEncuesta', visible: true },
        { id: 'goCounting', nombre: 'Ir al portal de conteos', icono: 'assessment', bloqueado: true, funcion: 'portalConteos', visible: true },
        { id: 'goSurveyMas50', nombre: 'Ir a la encuesta +50', icono: 'send', bloqueado: true, funcion: 'irEncuestaMas50', visible: true },
        { id: 'goCounting_more50', nombre: 'Ir al portal de conteos +50', icono: 'assessment', bloqueado: true, funcion: 'portalConteosNormaMas50', visible: false },
        { id: 'goSurveyMenos50', nombre: 'Ir a la encuesta -50', icono: 'send', bloqueado: true, funcion: 'irEncuestaMenos50', visible: true },
        { id: 'goCounting_less50', nombre: 'Ir al portal de conteos -50', icono: 'assessment', bloqueado: true, funcion: 'portalConteosNormaMenos50', visible: false },
        { id: 'genCountingUrl', nombre: 'Generar enlace externo al portal de conteos', icono: 'vpn_key', bloqueado: true, funcion: 'generarUrlConteos', visible: true },
        { id: 'copyCountingUrl', nombre: 'Copiar enlace externo al portal de conteos', icono: 'vpn_key', bloqueado: true, funcion: 'copiarUrlConteos', visible: false },
        { id: 'updateCounting', nombre: 'Sincronizar con portal de conteos', icono: 'cached', bloqueado: true, funcion: 'sincronizarPortalConteos', visible: true },
        { id: 'verRecord', nombre: 'Ver recordatorios', icono: 'event_note', bloqueado: true, funcion: 'verRecordatorios', visible: true },
        { id: 'verAvisos', nombre: 'Ver avisos', icono: 'event_note', bloqueado: true, funcion: 'verAvisos', visible: true },
        { id: 'verFechIniCie', nombre: 'Fecha de inicio / termino', icono: 'event_note', bloqueado: true, funcion: 'verFechIniCie', visible: true },
        { id: 'addPro', nombre: 'Añadir prorroga', icono: 'calendar_today', bloqueado: true, funcion: 'addProrroga', visible: true },
        { id: 'surveyClose', nombre: 'Cerrar encuesta', icono: 'power_settings_new', bloqueado: true, funcion: 'cerrarEncuesta', visible: true },
        { id: 'surveyOpen', nombre: 'Abrir encuesta', icono: 'power_settings_new', bloqueado: true, funcion: 'abrirEncuesta', visible: false },
        { id: 'enviaCorreos', nombre: 'enviaCorreos', icono: 'mark_email_read', bloqueado: true, funcion: 'enviaCorreos', visible: true },
        { id: 'cancelarEnvios', nombre: 'Cancelar envio de correos', icono: 'event_busy', bloqueado: true, funcion: 'cancelarEnvios', visible: true },
        { id: 'descaDemo', nombre: 'Permitir descargar demograficos', icono: 'arrow_downward', bloqueado: true, funcion: 'ActualizaDemographicsPdfStatus', visible: false, switch: false},

      ]
    },
    {
      nombre: 'Gestor de archivos',
      id: 'filemanager',
      visible: true,
      acciones: [
        { id: 'goPriv', nombre: 'Ver carpeta privada', icono: 'folder', bloqueado: true, funcion: 'verCloud', visible: true },
        { id: 'goPub', nombre: 'Ver carpeta pública', icono: 'folder_shared', bloqueado: true, funcion: 'verCloudPublico', visible: true },
      ]
    },
    {
      nombre: 'Resultados',
      id: 'resultados',
      visible: true,
      acciones: [
          { id: 'auditMan', nombre: '', icono: 'assignment_turned_in', bloqueado: true, funcion: 'auditoriaManual',visible: true },
        { id: 'processRes', nombre: 'Procesar resultados', icono: 'settings', bloqueado: true, funcion: 'cierreManual',visible: false },
        { id: 'masterTable', nombre: 'Comprobación de la encuesta', icono: 'table_chart', bloqueado: true, funcion: 'masterTable', visible: true,
          subFuncion: [
            { id: 'syncMT', icono: 'cached', funcion: 'sincronizarMasterTable', activa: false },
          ]
        },
        { id: 'lockRes', nombre: 'Bloquear resultados', icono: 'lock', bloqueado: true, funcion: 'bloquearResultados', visible: true, switch: false },
        { id: 'verRes', nombre: 'Ver resultados', icono: 'show_chart', bloqueado: true, funcion: 'verResultIframe', visible: true,
          subFuncion: [
          { id: 'tipoResu', icono: 'settings', funcion: 'setTipoResu', activa: false },
          { id: 'tipoResuV2', icono: 'show_chart', funcion: 'versionResultV2', activa: false },
          ] },
        { id: 'upNameIcon', nombre: 'Actualizar nombre', icono: 'edit', bloqueado: true, funcion: 'updNameIcon', visible: true,
          subFuncion: [
            { id: 'logoEmpresa', icono: 'import_export', funcion: 'cambiaLogoEmpresa_paso1', activa: false },
            { id: 'previewLogoEmp', icono: 'zoom_in', funcion: 'previewLogoEmp', activa: false },
            { id: 'updateDatCerti', icono: 'event', funcion: 'updateDatCerti', activa: false },
          ]
        },
        { id: 'regCertifi', nombre: 'Regenerar certificado', icono: 'security', bloqueado: true, funcion: 'selectIdiomaCertificado', visible: true,
          subFuncion: [
            { id: 'logoCert', icono: 'import_export', funcion: 'cambiaLogoCert_paso1', activa: false },
            { id: 'previewCert', icono: 'zoom_in', funcion: 'previewCert', activa: false },
            { id: 'multiSite', funcion: 'activaMultiSite', activa: false, switch: false },
            { id: 'multiSiteText', icono: 'view_headline', funcion: 'cambiaTextoMultiSite', activa: false },
          ]
        },
        { id: 'verConfigResult', nombre: 'Ver configuracion resultados', icono: 'dashboard', bloqueado: true, funcion: 'verConfigResult', visible: true, },

      ]
    },
    {
      nombre: 'Culture Audit',
      id: 'cultureaudit',
      visible: true,
      acciones: [
        { id: 'verCultureAudit', nombre: 'ver Culture audit', icono: 'send', bloqueado: true, funcion: 'verCultureAudit',visible: true },
        { id: 'libeCultureBrief', nombre: 'Liberación de Culture Brief', icono: 'published_with_changes', bloqueado: true, funcion: 'libeCultureBrief',visible: true },
        { id: 'confirReviCultureAudit', nombre: 'Activar Culture Audit', icono: 'published_with_changes', bloqueado: true, funcion: 'confirReviCultureAudit',visible: true, switch: false},
        { id: 'cambiaCultureBrief', nombre: 'Cambiar de Culture Brief', icono: 'published_with_changes', bloqueado: true, funcion: 'cambiaCultureBrief',visible: false },
      ]
    },
    {
      nombre: 'Web company Profile',
      id: 'webcompro',
      visible: true,
      acciones: [
        { id: 'verWebComPro', nombre: 'Regenerar certificado', icono: 'business', bloqueado: true, funcion: 'verWCPIframe', visible: true,
          subFuncion: [
            { id: 'logoCert', icono: 'import_export', funcion: 'cambiaLogoCert_paso1', activa: false },
            { id: 'previewCert', icono: 'zoom_in', funcion: 'previewCert', activa: false },
            { id: 'updateStatusWCP', funcion: 'updateStatusVisibilityWCP', activa: false, switch: false },
          ]
        },
        { id: 'crearClave', nombre: 'Acceso wcp externo', icono: 'add_task', bloqueado: true, funcion: 'crearClaveWcp', visible: true},
        { id: 'verDatWPC', nombre: 'Ver datos de acceso al perfil de la empresa externo', icono: 'visibility', bloqueado: true, funcion: 'CopyClaveWcp', visible: true,
        subFuncion: [
          { id: 'visibleSwitchWCP', funcion: 'visibleSwitchWCP', activa: false, switch: false },
        ]},

      ]
    },
  ];

  datosSurveyCheck: any;
  datosEmpresaProducto: any = {};
  idiomaActual: string;
  claveConteos: string;
  primLlamadaPortalExt: boolean; //tiene que existir para que el status del portal externo solo se llame una vez, por cuestiones asincronas alv
  datosMasterTable: any = [];

  // brokersTipoResuEditable = [1];  //brokers que pueden elegir el tipo de version de resultados
  versionSuccesGo: boolean;
  brokerConfig: any;
  carpetaImagenes: any;
  direccionRaiz = "./4fa42aa0ba652605cada43bca0fc6389/";
  nombreEmpresa: string;
  jsonLogos: any;
  infoAudManual: any;
  rutaLogoEmpresa: string;
  versionCloudNueva: boolean;
  fechaNuevaVersion = "2021-10-04";   //este dia se adaptó la carga del logo y certificado al fileserver
  textoCertificado: string;
  datosBanderas: any;
  linksCultureAuditCGOX: any;
  linkCultureAudit: string;
  tiposCorreos: any[] = [];
  reason="Por que no es necesario que se muestre";
  filtroProrroga:any;
  getdataWPCPassword:any;
  getdataWPCPEnlace:any;
  enviosCancelables: boolean;
  gralResultActivo:boolean;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private translateSrv: TranslateService,
    private surveyServ: SurveyStatusV2Service,
    private snackBar: MatSnackBar,
    private _dialog: LyDialog,
    private _cd: ChangeDetectorRef,
    private cloudService: CloudService,
    private wcp: WebCompProfileService,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; this.obtieneLinkCAIdioma(); });
  }

  ngOnInit() {
    this.getLogoEmpresa();
    this.getInfoEmpresa();
    this.getJsonLogos();
    this.getBrokerConfig();
    this.resultFuncionando();
    this.setStatusBoton.subscribe((datos:any) => {
      if (datos != null) {
        // console.log("statusBoton:",datos);
        setTimeout(() => {
          this.categorias.forEach(categoria => {
            let boton = categoria.acciones.find(item => item.id == datos.id);
            if(boton != undefined){
              boton.bloqueado = datos.status;
              boton.visible = datos.visible != undefined ? datos.visible : boton.visible;
            }
          });
        }, 1000);
      }
    });

    this.infoSurveyCheck.subscribe((datos:any) => {
      if (datos != null) {
        this.datosSurveyCheck = datos;
        this.datosMasterTable = [];
      }
    });

    this.infoEmpresaProducto.subscribe((datos:any) => {
      // console.log('infoEmpresaProducto',datos);
      if (datos.reinciarDatos!=undefined) {
        this.datosEmpresaProducto={};
        this.primLlamadaPortalExt=undefined;
        this.categorias.forEach(categoria => {
          categoria.acciones.forEach(accion => {
            console.log('accion',accion);
            accion.bloqueado=true;
          });

        });
      }

      for(let prop in datos){
        this.datosEmpresaProducto[prop] = datos[prop];
      }

      if(this.datosEmpresaProducto.idEmpresa && this.datosEmpresaProducto.idProducto && !this.primLlamadaPortalExt){
        console.log('this.datosEmpresaProducto++++++++++++',JSON.parse(JSON.stringify(this.datosEmpresaProducto)));
        this.primLlamadaPortalExt = true;

        if (this.datosEmpresaProducto.tipoProducto!=70) {
          this.getClaveConteos();
          this.getBanderasProducto();
          this.getTiposCorreos();
          this.habilitaCancelarEnvios(this.datosEmpresaProducto.datosProducto.fechaLanzamiento);
        }


        if(this.datosEmpresaProducto.tipoProducto != 3 ){
          console.log("entro esto que no debe entartb dsjcsi");
          // this.getInfoAudManual();
          // this.getBloqueoResultados();
          // this.activarBoton('masterTable', true, null, 'syncMT');
          switch (this.datosEmpresaProducto.tipoProducto) {

            case 40: case 20: case 1: case 75: //certificar 3
            console.log('Si se mando a llamar  esta funcion perrona');
              this.activarBoton('descaDemo',false,true);
              this.getUrlCA_Cert3();
              this.getStatusPublicWebComProfile();
              this.categorias[4].visible=true;
              this.getInfoAudManual();
              this.getBloqueoResultados();
              this.getDemographicsPdfStatus();
              this.activarBoton('masterTable', true, null, 'syncMT');
              this.getInfoAccesoWPC();

            break;
            case 52:  //CGO express
              this.getUrlCA_CGOX();
              this.categorias[4].visible=false;
              this.getInfoAudManual();
              this.getBloqueoResultados();
              this.activarBoton('masterTable', true, null, 'syncMT');
            break;
            case 63:  //Nuevo normas 35
            // this.categorias[1].visible=false;
            // this.categorias[2].visible=false;
            // this.categorias[3].visible=false;
            // this.categorias[4].visible=false;
            console.log('categorias',this.categorias);
            break;
            case 70:  //Nuevo normas 35
            this.activarBoton('descaDemo',false,false);
            this.getInfoAccesoWPC();
            // this.categorias.forEach(categoria => {
            //   categoria.acciones.forEach(accion => {
            //     console.log('accion',accion);
            //
            //     accion.bloqueado=true;
            //   });
            //
            // });

            break;
            case 68:
            this.getUrlCA_Cert3();


            break;
            default:
            this.getInfoAudManual();
            this.getBloqueoResultados();
            this.activarBoton('masterTable', true, null, 'syncMT');
            this.categorias[4].visible=false;

            break;
          }
          if (this.datosEmpresaProducto.fechasProrrogasRegis) {
            console.log('entro aqui ');
            this.filtroProrroga= (d: Date | null): boolean => {
              var moment = require('moment');
              // const diaInicial = moment(this.datosEmpresaProducto.detalles.fechasProrrogas[0].fecha);
              const diaInicial = moment(this.datosEmpresaProducto.fechasProrrogasRegis[0].fecha);
              const diaActual = moment(d || new Date());
              return diaActual.isAfter(diaInicial);
            };
          }else{
            if (localStorage.getItem('tipoIdProducto')=='52') {
              this.filtroProrroga= (d: Date | null): boolean => {
                var moment = require('moment');
                const diaInicial = moment(this.datosEmpresaProducto.detalles.fechasProducto[1].fecha);
                const diaActual = moment(d || new Date());
                return diaActual.isAfter(diaInicial);
              };
            }else{
              switch (localStorage.getItem('tipoIdProducto')) {
                case '2': case '11': case '12': case '13': case '14': case '15': case '16':
                  console.log('this.datosEmpresaProducto.datosProducto.fechaCierre.fechaCierre',this.datosEmpresaProducto);
                  this.filtroProrroga= (d: Date | null): boolean => {
                    var moment = require('moment');
                    const diaInicial = moment(this.datosEmpresaProducto.detalles.fechasProducto[1].fecha);
                    const diaActual = moment(d || new Date());
                    return diaActual.isAfter(diaInicial);
                  };
                  break;
                case '63':

                  break;

                default:
                this.filtroProrroga= (d: Date | null): boolean => {
                  var moment = require('moment');
                  const diaInicial = moment(this.datosEmpresaProducto.datosProducto.fechaCierre.fechaCierre);
                  const diaActual = moment(d || new Date());
                  return diaActual.isAfter(diaInicial);
                };
                  break;
              }

            }
          }
        }else{
          // console.log('dchsas');
          // this.categorias[1].visible=false;
          // this.categorias[2].visible=false;
          // this.categorias[3].visible=false;
          // this.categorias[4].visible=false;
          // console.log('categorias',this.categorias);

            this.filtroProrroga= (d: Date | null): boolean => {
              var moment = require('moment');
              const diaInicial = moment(this.datosEmpresaProducto.detalles.fechasProducto[1].fecha);
              const diaActual = moment(d || new Date());
              return diaActual.isAfter(diaInicial);
            };

        }
        this.getMarkCulturAudit();
      }
    });

    if (localStorage.getItem('levelUser_tmp') == '3') {
      let botProcRes:any = this.datosBoton('processRes');
      botProcRes.visible = true;
    }
  }

  obtieneLinkCAIdioma(){
    if(this.datosEmpresaProducto.tipoProducto){
      switch (this.datosEmpresaProducto.tipoProducto) {
        case 40: case 20: case 1: //certificar 3
          this.getUrlCA_Cert3();
        break;
        case 52:  //CGO express
          this.getUrlCA_CGOX();
        break;
      }
    }
  }

  prro(){
    // console.log("hola prro");

  }

  ////////////// FUNCIONES AUTOMATICAS

  getLogoEmpresa(){
    this.surveyServ.getLogoEmpresa().subscribe((respuesta:any) => {
      // console.log("getLogoEmpresa:",respuesta);
      if (respuesta.message == "702") { //si hay imagen
        let url = DATOS_API.urlLogos.split(":");
        this.rutaLogoEmpresa = `${url[1]}/surveyadministrator/backend/${respuesta.rutaArchivo}`;
        //activa el boton de cambiar imagen y vista previa
        let botLogoEmp:any = this.datosBoton('upNameIcon','logoEmpresa');
        let botPrevEmp:any = this.datosBoton('upNameIcon','previewLogoEmp');
        let updateDatCerti:any = this.datosBoton('upNameIcon','updateDatCerti');
        botLogoEmp.activa = true;
        botPrevEmp.activa = true;
        updateDatCerti.activa = true;
      } else if (respuesta.message == "701") {  //no hay imagen
      }
    });
  }
  getInfoEmpresa(){
    this.cloudService.getInfoEmpresa(localStorage.getItem('companyID')).subscribe((respuesta:any) => {
      // console.log("getInfoEmpresa:",respuesta);
      if(respuesta.message == 'Success'){
        this.nombreEmpresa = respuesta.data.nombreEmpresa;
        if(moment(respuesta.createdAt).isAfter(moment(this.fechaNuevaVersion)) ){  //si la fecha es posterior a la indicada, nueva version
          this.versionCloudNueva = true;
          this.nuevo_gotoRaiz();
        } else{   //version anterior
          this.versionCloudNueva = false;
          this.direccionRaiz = this.direccionRaiz + localStorage.getItem('companyID') + "/";
          this.getRaiz();
        }
      }
    });
  }
  //// SERVICIOS FILE MANAGER 1.0
  getRaiz(){
    let idEmpresa = localStorage.getItem('companyID');
    this.cloudService.getCarpetaRaiz(idEmpresa).subscribe( (respuesta:any) => {
      // console.log("getRaiz:",respuesta);
      if(respuesta.success){
        if(respuesta.carpetas.length == 0){
          this.guardaCarpeta('editorImages');
        } else{
          // let datosCarpetaImgs = respuesta.carpetas.find(item => item.nombre == 'editorImages');
          // BUSCA LA CARPETA QUE TENGA EN LA UBICACION EL ID DE LA EMPRESA
          let datosCarpetaImgs = respuesta.carpetas.find(item => item.nombre == 'editorImages' && item.ubicacion.includes(localStorage.getItem('companyID')));
          if(datosCarpetaImgs != undefined){
            this.carpetaImagenes = datosCarpetaImgs;
          } else{
            this.guardaCarpeta('editorImages');
          }
        }
      }
    });
  }
  guardaCarpeta(nombre:string, ubicacion?:string, carpetaAssets?:any){
    let datos:any = {
      nombre: nombre,
      ubicacion: ubicacion != undefined ? ubicacion : this.direccionRaiz,
      empresaId: localStorage.getItem('companyID')
    };
    if(carpetaAssets){
      datos.carpetaId = carpetaAssets._id;  //solo cuando no es la raiz
    }
    // console.log(datos);
    this.cloudService.guardaCarpetaITBM(datos).subscribe((respuesta:any) => {
      // console.log("guardaCarpetaITBM:",respuesta);
      if(respuesta.success){
        if(nombre == 'editorImages'){
          this.getRaiz();
        }
      }
    }, error => {
      console.log(error);
    });
  }
  //// SERVICIOS FILE SERVER
  nuevo_gotoRaiz(){
    this.cloudService.getArchivos_nuevo("").subscribe((respuesta:any) => {
      // console.log("getArchivos_nuevo raiz:",respuesta);
      if(respuesta.success){
        this.nuevo_getCarpeta(null, null, true);
      } else{
        this.nuevo_creaCarpetaRaiz();
      }
    });
  }
  nuevo_creaCarpetaRaiz(nombreCarpeta?:string){
    const datos = {
      empresaId: localStorage.getItem('companyID'),
      folderId: nombreCarpeta == undefined ? null : this.carpetaImagenes._id,
      path: nombreCarpeta == undefined ? localStorage.getItem('companyID') : this.carpetaImagenes.path + '/' + nombreCarpeta,
      itbm: nombreCarpeta == undefined ? true : false
    };
    this.cloudService.creaCarpeta_nuevo(datos).subscribe((respuesta:any) => {
      // console.log("creaCarpeta_nuevo:",respuesta);
      this.nuevo_gotoRaiz();
      // this.nuevo_getCarpeta(this.carpetaImagenes);
    })
  }
  nuevo_getCarpeta(datosFolder?:any, subcarpetas?:boolean, raiz?: boolean){
    let folderId: string = null;
    if(datosFolder){
      this.carpetaImagenes = datosFolder;
      folderId = datosFolder._id;
    }
    this.cloudService.getCarpetas_nuevo(folderId).subscribe((respuesta_2:any) => {
      if(respuesta_2.success){
        /// PRIMER PASO, OBTENCION DE DATOS DE LA CARPETA
        if(!subcarpetas){
          if(raiz){
            this.carpetaImagenes = respuesta_2.folders[0];
          }
          console.log("datosCarpetaActual:",this.carpetaImagenes);
          //hacer el get de nuevo para obtener las subcarpetas
          this.nuevo_getCarpeta(this.carpetaImagenes, true);
        } else{ /// SEGUNDO PASO, OBTENCION DE LISTA DE SUBCARPETAS Y ARCHIVOS
          const listaSubcarpetasActual: any = respuesta_2.folders;
          console.log("subcarpetas de la actual:",listaSubcarpetasActual);

          // BUSCA LA CARPETA QUE TENGA EN LA UBICACION EL ID DE LA EMPRESA
          const datosCarpetaImgs = listaSubcarpetasActual.find(item => item.path.includes('editorImages'));
          console.log("datosCarpetaImgs:",datosCarpetaImgs);

          if(datosCarpetaImgs != undefined){
            this.carpetaImagenes = datosCarpetaImgs;
          } else{
            this.nuevo_creaCarpetaRaiz('editorImages');
          }
        }
      }
    });
  }

  getJsonLogos(){
    this.surveyServ.getJsonLogos().subscribe((respuesta:any) => {
      // console.log("getJsonLogos:",respuesta);
      if(respuesta.success){
        this.jsonLogos = respuesta.jsonLogos;
      }
    });
  }

  getBrokerConfig(){
    this.surveyServ.getBrokerConfig().subscribe((respuesta:any) => {
      // console.log("getBrokerConfig:",respuesta);
      this.brokerConfig = respuesta.catBrokerConfiguration;
      let instituto = parseInt(localStorage.getItem('instituto_id'));
      this.setVersionResuEditable(instituto);
      this.setLogoCertEditable(instituto);
      this.setLogoEmpresa(instituto);
    });
  }

  getBanderasProducto(){
    let refDatos = this.datosEmpresaProducto;
    this.surveyServ.getBanderasProducto(refDatos.idEmpresa, refDatos.idProducto).subscribe((respuesta:any) => {
      console.log("getBanderasProducto:==========================================",respuesta);
      if(respuesta.success){

        this.datosBanderas = respuesta;
        delete this.datosBanderas.success;
        //activa el botón del texto multisite
        this.activarBoton('regCertifi', true, null, 'multiSite');
        switch (this.datosEmpresaProducto.tipoProducto) {
          case 3: case 63:
            // console.log('Nohace nada de nada ');

            break;

          default:
          this.getTextoCertificado();
          this.versionSuccesGo = respuesta.versionSuccesGo;
          localStorage.setItem('versionResultSuccesGo',this.versionSuccesGo.toString())
            break;
        }
        if(this.datosBanderas.certification_key == true){
          let datosSwitchMultiSite: any = this.datosBoton('regCertifi','multiSite');
          console.log("datosMultiSite:",datosSwitchMultiSite);
          datosSwitchMultiSite.switch = this.datosBanderas.certification_key;
          this.activarBoton('regCertifi', true, null, 'multiSiteText');
        }

        this.activarBoton('verWebComPro', true, null, 'updateStatusWCP');
      }
    });
  }

  getTextoCertificado(){

    let token = this.datosEmpresaProducto.datosProducto.tokenConfig != undefined ? this.datosEmpresaProducto.datosProducto.tokenConfig : this.datosEmpresaProducto.datosProducto.surveyToken;
    this.surveyServ.getTextoCertificado(token).subscribe((respuesta:any) => {
      // console.log("getTextoCertificado:",respuesta);
      if(respuesta.success){
        this.textoCertificado = respuesta.result.oMultiSiteString
      }
    });
  }

  getInfoAudManual(){
    this.surveyServ.getInfoAudManual().subscribe((respuesta:any) => {
      // console.log("getInfoAudManual:",respuesta);
      if(respuesta.success){
        this.infoAudManual = respuesta.result;
      }
    });
  }

  setVersionResuEditable(instituto:number){
    // if(this.brokersTipoResuEditable.includes(instituto)){
    if(this.brokerConfig.versionResultsCert.includes(instituto)){
      let botResuEdit:any = this.datosBoton('verRes','tipoResu');
      botResuEdit.activa = true;
      if (localStorage.getItem('levelUser_tmp') == '3') {
        let botResuV2:any = this.datosBoton('verRes','tipoResuV2');
        botResuV2.activa = true;
      }

    }
  }
  setLogoCertEditable(instituto:number){
    let esperaJsonLogo = setInterval(() => {
      if(this.jsonLogos){
        let objInstituto = this.brokerConfig.logoCertificado.find(item => item.broker == instituto);
        if(objInstituto != undefined){
          if(objInstituto.productos.includes(localStorage.getItem('tipoProducto')) ){
            let botLogoCert:any = this.datosBoton('regCertifi','logoCert');
            let botPrevCert:any = this.datosBoton('regCertifi','previewCert');
            botLogoCert.activa = true;
            botPrevCert.activa = this.jsonLogos.logos.certificate.set;
          }
        }
        clearInterval(esperaJsonLogo);
      }
    }, 0);
  }
  setLogoEmpresa(instituto:number){
    let esperaJsonLogo = setInterval(() => {
      if(this.jsonLogos){
        let objInstituto = this.brokerConfig.logoCertificado.find(item => item.broker == instituto);
        if(objInstituto != undefined){
          if(objInstituto.productos.includes(localStorage.getItem('tipoProducto')) ){
            if(this.jsonLogos.logos.company.set == false){
              if(this.rutaLogoEmpresa){
                this.jsonLogos.logos.company.image = this.rutaLogoEmpresa;
                this.jsonLogos.logos.company.set = true;
                this.surveyServ.updateJsonLogos(this.jsonLogos._id, { logos: this.jsonLogos.logos }).subscribe((respuesta:any) => {
                  console.log('updateJsonLogos:',respuesta);
                });
              }
            }
          }
        }
        clearInterval(esperaJsonLogo);
      }
    }, 0);
  }
  accionActiva(accion){ return accion.activa == true };

  getBloqueoResultados(){
    let token = this.datosEmpresaProducto.datosProducto.tokenConfig != undefined ? this.datosEmpresaProducto.datosProducto.tokenConfig : this.datosEmpresaProducto.datosProducto.surveyToken;
    this.surveyServ.getBloqueoResultados(token).subscribe((respuesta:any) => {
      // console.log("getBloqueoResultados:",respuesta);
      if(respuesta.success){
        const datosBotLockResu: any = this.datosBoton('lockRes');
        respuesta.result.status == 1 ? datosBotLockResu.switch = true : false;
      }
    });
  }

  getDemographicsPdfStatus(){
    // let token = this.datosEmpresaProducto.datosProducto.tokenConfig != undefined ? this.datosEmpresaProducto.datosProducto.tokenConfig : this.datosEmpresaProducto.datosProducto.surveyToken;
    let productoId = this.datosEmpresaProducto.idProducto;

    this.surveyServ.getStatusDemographicsPdf(productoId).subscribe((respuesta:any) => {
      console.log('respuesta',respuesta);

      if(respuesta.succes){
        const datosBotLockResu: any = this.datosBoton('descaDemo');
        respuesta.downloadPDF.isDownloadPdf == true ? datosBotLockResu.switch = true : false;
      }
    });
  }

  ActualizaDemographicsPdfStatus(){
    let instituto = parseInt(localStorage.getItem('instituto_id'));
    let productoId = this.datosEmpresaProducto.idProducto;
    let datos={
      surveyToken:this.datosEmpresaProducto.datosProducto.tokenConfig != undefined ? this.datosEmpresaProducto.datosProducto.tokenConfig : this.datosEmpresaProducto.datosProducto.surveyToken,
      enable:true,
    }

    this.surveyServ.setEnableDemographicsPdf(productoId,instituto,datos).subscribe((respuesta:any) => {
      console.log('respuesta',respuesta);
      this.openSuccessSnackBar(this.translateSrv.instant("ACCIONES.MODALES.SUCC_UPDA_NAME"),'');
      if(respuesta.success){
        this.getDemographicsPdfStatus();
      }
    });
  }

  getUrlCA_Cert3(){
    this.linkCultureAudit = undefined;
    const datosUsuario = JSON.parse(localStorage.getItem('userData'));
    this.surveyServ.getUrlCA_Cert3(this.datosEmpresaProducto.idProducto, this.idiomaActual.toUpperCase(), datosUsuario.user).subscribe((respuesta:any) => {
      console.log("getUrlCA_Cert3:",respuesta);
      if(respuesta.success){
        this.activarBoton('verCultureAudit', false);
        this.linkCultureAudit = respuesta.link;
        this.activarBoton('cancelarEnvios', false);
      }else{
        this.activarBoton('verCultureAudit', true);
      }
    });
  }

  getUrlCA_CGOX(){
    // let userData = JSON.parse(localStorage.getItem('userData'));
    this.activarBoton('verCultureAudit', true);
    this.linkCultureAudit = undefined;
    let idiomaActual: string;
    switch(this.translateSrv.currentLang){
      case 'es': case 'zh2': case 'tr': idiomaActual = this.translateSrv.currentLang.toUpperCase(); break;
      default: idiomaActual = 'EN';
    }
    let datos = {
      // user: userData.user,
      lang: idiomaActual
    };
    this.linksCultureAuditCGOX = [];
    this.surveyServ.getUrlCA_CGOX(datos).subscribe((respuesta:any) => {
      console.log("getUrlCA_CGOX:",respuesta);
      if(respuesta.success){
        this.linksCultureAuditCGOX = respuesta.cultureAuditV2;
        let coincidencia = this.linksCultureAuditCGOX.find(item => item.fecha == this.datosEmpresaProducto.fechaProducto);
        if(coincidencia != undefined){
          this.linkCultureAudit = coincidencia.link;
          this.activarBoton('verCultureAudit', false);
        }
      }
    });
  }

  habilitaCancelarEnvios(fechaLanzamiento:string){
    let refDatos = this.datosEmpresaProducto;
    const fechaActual = momentTz.tz(refDatos.zonasUTC[refDatos.indiceZona].zona);
    const fechaLanzMoment = momentTz.tz(fechaLanzamiento, refDatos.zonasUTC[refDatos.indiceZona].zona);
    // console.log("FECHA1:",fechaActual.clone().format());
    // console.log("FECHA2:",fechaLanzMoment.clone().subtract(2,'hours').format());

    if(fechaActual.isBefore(fechaLanzMoment.clone().subtract(2,'hours'))){
      this.activarBoton('cancelarEnvios', false);
      this.enviosCancelables = true;
    } else{
      if(fechaActual.isBefore(fechaLanzMoment.clone())){
        this.activarBoton('cancelarEnvios', false);
        this.enviosCancelables = false;
      } else{
        this.activarBoton('cancelarEnvios', true);
      }
    }
  }

  ////////////// FUNCIONES NO AUTOMATICAS

  activarBoton(id:string, status:boolean, visible?:boolean, subAccion?:string){
    this.categorias.forEach(categoria => {
      let boton = categoria.acciones.find(item => item.id == id);
      if(boton != undefined){
        if(subAccion){
          let subFunc = boton.subFuncion.find(item => item.id == subAccion);
          if(subFunc != undefined){
            subFunc.activa = status;
            // subFunc.visible = visible != undefined ? visible : subFunc.visible;
          }
        } else{
          boton.bloqueado = status;
          boton.visible = visible != undefined ? visible : boton.visible;
        }
      }
    });
  }

  datosBoton(id:string, subAccion?:string){
    let datos: any;
    this.categorias.forEach(categoria => {
      let boton = categoria.acciones.find(item => item.id == id);
      if(boton != undefined){
        if(subAccion){
          let datosSubAcc = boton.subFuncion.find(item => item.id == subAccion);
          if(datosSubAcc != undefined){
            datos = datos == undefined ? datosSubAcc : datos;
            // return datos;
          }
        } else{
          datos = datos == undefined ? boton : datos;
          // return datos;
        }
      }
    });
    return datos;
  }

  surveyCheck(){
    const dialogRef = this.dialog.open(SurveyCheckComponent, {
      width: '40%',
      data: {
        datos: this.datosSurveyCheck,
        titulo: 'TITULO',
        tipoModa:'surveyCheck'
      }
    });
  }

  masterTable(){
    let token = this.datosEmpresaProducto.datosProducto.tokenConfig != undefined ? this.datosEmpresaProducto.datosProducto.tokenConfig : this.datosEmpresaProducto.datosProducto.surveyToken;
    this.datosMasterTable = [];
    // if(this.datosMasterTable.length == 0){
      this.modalGuardado(5);
      this.surveyServ.getMasterTable(token).subscribe( (respuesta:any) => {
        // console.log("getMasterTable:",respuesta);
        if(respuesta.success){
          if(respuesta.records.length > 0){
            let iter = 1;
            for (let campo in respuesta.records[0]) {
              let datosSimulados = {
                IDdescription: iter,
                description: campo,
                name_section: campo,
                rowid: iter,
                // value: respuesta.records[0][campo] == null ? 'Sin datos' : respuesta.records[0][campo]
                value: respuesta.records[0][campo]
              };
              iter++;
              this.datosMasterTable.push(datosSimulados);
            }
            Swal.close();
            const dialogRef = this.dialog.open(SurveyCheckComponent, {
              width: '40%',
              data: {
                datos: this.datosMasterTable,
                titulo: 'TITULO_ALT'
              }
            });
          }
        }
      });
    // } else{
    //   const dialogRef = this.dialog.open(SurveyCheckComponent, {
    //     width: '40%',
    //     data: {
    //       datos: this.datosMasterTable,
    //       titulo: 'TITULO_ALT'
    //     }
    //   });
    // }
  }
  sincronizarMasterTable(){
    const datos = {
      empresaId: this.datosEmpresaProducto.idEmpresa,
      productoId: this.datosEmpresaProducto.idProducto
    };
    let sicronizando = this.translateSrv.instant("ACCIONES.MODALES.SINCRONIZARMT");
    Swal.fire({
      title: sicronizando,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    this.surveyServ.updateMasterTable(datos).subscribe((respuesta:any) => {
      // console.log("updateMasterTable:",respuesta);
      if(respuesta.success){
        Swal.close();
        this.openSuccessSnackBar(this.translateSrv.instant("AVANCES.SINCRONIZACION.SUCCESS"),'');
      }
    });
  }

  descargarEncuesta(){
    // console.log("datosEmpresa:",this.datosEmpresaProducto);
    let refDatos = this.datosEmpresaProducto;
    let datos: any = {
      fecha: refDatos.fechaProducto,
      idProducto: refDatos.idProducto,
      tipoProducto: refDatos.tipoProducto,
      plantilla: null,  //al parecer no se usa para nada :v
      idEmpresa: refDatos.idEmpresa,
      nombreEmpresa: refDatos.nombreEmpresa,
      codigoDeProyecto: refDatos.codigoProyecto,
      productoId: refDatos.tipoProducto,
      instituto: parseInt(localStorage.getItem('instituto_id'))
    };

    const dialogRef = this.dialog.open(DescargaEncuestaComponent, {
      width: '50%',
      data: datos
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  irEncuesta(){
    // console.log('datosEmpresaProducto',this.datosEmpresaProducto);

    window.open(this.datosEmpresaProducto.urlEncuesta, '_blank');
  }

  irEncuestaMenos50(){
    // console.log('datosEmpresaProducto',this.datosEmpresaProducto);

    window.open(this.datosEmpresaProducto.urlEncuestaNormaMenos50, '_blank');
  }

  irEncuestaMas50(){
    // console.log('datosEmpresaProducto',this.datosEmpresaProducto);

    window.open(this.datosEmpresaProducto.urlEncuestaNormaMas50, '_blank');
  }

  portalConteos(){
    this.router.navigate(['/portalControl/']);
  }

  portalConteosNormaMenos50(){
    // console.log('portalConteosNormaMenos50***');
    if(this.datosEmpresaProducto.tipoProducto == 3){  //Si es norma 35
      if(this.datosEmpresaProducto.datosProducto.idSurveyMenos){  //si es menos de 50
        localStorage.setItem('surveytype',"1");
      }
    } else if(this.datosEmpresaProducto.tipoProducto == 63){
      if(this.datosEmpresaProducto.datosProducto.idSurveyMenos){  //si es menos de 50
        localStorage.setItem('surveytype',"1");
      }
    }
    this.router.navigate(['/portalControl/']);
  }

  portalConteosNormaMas50(){
    // console.log('portalConteosNormaMas50***');
    if(this.datosEmpresaProducto.tipoProducto == 3){  //Si es norma 35
      if(this.datosEmpresaProducto.datosProducto.idSurveyMas){  //si es mas de 50
        localStorage.setItem('surveytype',"0");
      }
    }else if(this.datosEmpresaProducto.tipoProducto == 63){
      if(this.datosEmpresaProducto.datosProducto.idSurveyMas){  //si es mas de 50
        localStorage.setItem('surveytype',"0");
      }
    }
    this.router.navigate(['/portalControl/']);
  }

  generarUrlConteos(){
    let datos: any = {
      empresaId: this.datosEmpresaProducto.idEmpresa,
      productoId: this.datosEmpresaProducto.idProducto
    };
    switch (this.datosEmpresaProducto.tipoProducto) {
      case 1: case 20: case 40: case 41: case 42: case 43: //certificar 1 y productos 3.0
      datos.claveProducto = 1;
      break;
      case 2: case 11: case 12: case 13: case 14: case 15: case 16: //casos productos medir
      datos.claveProducto = 2;
      break;
      case 4: //caso producto pulse check v1
      datos.claveProducto = 4;
      datos.idSurvey = this.datosEmpresaProducto.datosProducto.idSurvey;
      break;
      case 52: //caso producto CGOX
      datos.claveProducto = 7;
      break;
    }
    this.surveyServ.saveConteosClaves(datos).subscribe( (data: any) => {
      this.claveConteos = data.clave._id;
      this.getClaveConteos();
    });
  }
  getClaveConteos(){
    let datos: any = {
      empresaId: this.datosEmpresaProducto.idEmpresa,
      productoId: this.datosEmpresaProducto.idProducto
    };
    switch (this.datosEmpresaProducto.tipoProducto) {
      case 1: case 20: case 40: case 41: case 42: case 43: case 2: case 11: case 12: case 13: case 14: case 15: case 16: //casos productos medir //certificar 1 y productos 3.0
      this.surveyServ.getClaveConteos(datos).subscribe( (data: any) => {
        // console.log("getClaveConteos:",data);
        if(data.success){
          this.activarBoton('genCountingUrl', true, false);
          this.activarBoton('copyCountingUrl', false, true);
          this.claveConteos = data.clave._id;
        }
      });
      break;
      case 4: //caso producto pulse check v1
      this.surveyServ.getClavesConteosPulse(datos).subscribe( (data: any) => {
        // console.log("getClavesConteosPulse:",data);
        if(data.success){
          this.activarBoton('genCountingUrl', true, false);
          this.activarBoton('copyCountingUrl', false, true);
          this.claveConteos = data.claves[0]._id;
        }
      });
      break;
      case 52: //caso producto cgoExpress
      this.surveyServ.getClaveConteos(datos).subscribe( (data: any) => {
        // console.log("getClaveConteos:",data);
        if(data.success){
          this.activarBoton('genCountingUrl', true, false);
          this.activarBoton('copyCountingUrl', false, true);
          this.claveConteos = data.clave._id;
        }
      });
      break;

    }
  }

  copiarUrlConteos(){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = `${DATOS_API.urlConteos}${this.claveConteos}`;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    Swal.fire({
      icon: 'success',
      title: this.translateSrv.instant('ACCIONES.MODALES.URL'),

      confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
    });
  }

  sincronizarPortalConteos(){
    let sicronizando = this.translateSrv.instant("AVANCES.SINCRONIZACION.SINCRONIZANDO");
    let sincronizacionCompleta = this.translateSrv.instant("AVANCES.SINCRONIZACION.SUCCESS");
    let cerrar = this.translateSrv.instant("AVANCES.BOTONES-MODALES.ELIMINAR.CERRAR");
    this.modalGuardado(3);
    // Swal.fire({
    //   title: sicronizando,
    //   didOpen: () => {
    //     Swal.showLoading()
    //   }
    // });
    let refDatos = this.datosEmpresaProducto;
    let datos = {
      brokerId: localStorage.getItem('instituto_id'),
      idSurvey: refDatos.datosProducto.idSurvey,
      productoId: refDatos.idProducto,
      tokenConfig: refDatos.datosProducto.tokenConfig,


    };
    this.surveyServ.sincronizarConteos(datos).subscribe((data:any) => {
      Swal.close();
      if(data.success){
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: sincronizacionCompleta,
          showConfirmButton: true,

          confirmButtonText: cerrar
        })
      }
    }, error  => {
      console.log("error");
    });
  }

  addProrroga(){
    this.calendarioProrroga.open();
  }
  updateDatCerti(){
    let refDatos = this.datosEmpresaProducto;
    const dialogRef = this.dialog.open(ModalComponentAcciones, {
      width: '50%',
      disableClose: true,
      data: {
        tipo: 'certifica',
        info:this.datosEmpresaProducto.datosProducto,
        fechaCierre:this.datosEmpresaProducto.datosProducto.fechaCierre.fechaCierre,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("resultado:",result);
      if(result != undefined){

      }
    });


  }

  fechaSeleccionada(event){
    let fechaElegida = event.value;
    let fechaMoment = moment(fechaElegida).format('YYYY-MM-DD');
    // let fechaAnterior = this.fechaProrroga;
    let fechaAnterior = this.datosEmpresaProducto.detalles.fechasProducto[2].fecha;
    console.log("fechaEvent:",fechaElegida);
    console.log("fechaMoment:",fechaMoment);
    // this.fechaProrroga = fechaMoment;
    this.datosEmpresaProducto.detalles.fechasProducto[2].fecha = fechaMoment;
    setTimeout(() => {
      $("#timepicker").click();
    }, 200);
  }
  horaSeleccionada(event){
    let refDatos = this.datosEmpresaProducto;
    console.log("refDatos:",refDatos);
    console.log("horaSel:",event);
    let hora24 = moment(event, ["h:mm A"]).format("HH:mm");
    refDatos.detalles.fechasProducto[2].fecha = refDatos.detalles.fechasProducto[2].fecha + " " + hora24;

    let fechaActual = momentTz.tz(refDatos.zonasUTC[refDatos.indiceZona].zona);

    let fechaActualLocal = moment().utc(true);
    let fechaActualInsti = momentTz.tz(refDatos.zonasUTC[refDatos.indiceZona].zona).utc(true);
    let diferenciaLocalInstituto = fechaActualLocal.diff(fechaActualInsti, 'seconds');
    let fechaElegidaAjustada: any;
    if(diferenciaLocalInstituto < 0){
      fechaElegidaAjustada = momentTz.tz(refDatos.zonasUTC[refDatos.indiceZona].zona).subtract((diferenciaLocalInstituto*-1), 'seconds');
    }
    else{
      fechaElegidaAjustada = momentTz.tz(refDatos.zonasUTC[refDatos.indiceZona].zona).add(diferenciaLocalInstituto, 'seconds');
    }
    let utcActual = moment.utc();
    let diferenciaUtc = moment.parseZone(momentTz.tz(refDatos.zonasUTC[refDatos.indiceZona].zona).format()).utcOffset();
    let fechaSeleccionada = momentTz.tz(refDatos.detalles.fechasProducto[2].fecha,refDatos.zonasUTC[refDatos.indiceZona].zona);
    let diferenciaMinutos = momentTz.tz(refDatos.detalles.fechasProducto[2].fecha,refDatos.zonasUTC[refDatos.indiceZona].zona).diff(fechaActual, 'seconds');
    let fechaActualTransformada = moment(fechaActual).add(diferenciaMinutos, 'seconds');
    diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'minutes'); //se le añade 1 minutos porque siempre se desfasa alv -_-

    refDatos.detalles.fechasProducto[2].fecha = moment(fechaActual).add(diferenciaMinutos, 'seconds').add(1, 'minutes').utc(true).toISOString();
    console.log("Esta fecha esta en  Formato UTC0: ", refDatos.detalles.fechasProducto[2].fecha);

    this.saveProrrogaEncuesta(fechaTransformadaMasDifUtc.utc(true).toISOString());
  }

  saveProrrogaEncuesta(fechaElegida:string){
    let refDatos = this.datosEmpresaProducto;
    let token = this.datosEmpresaProducto.datosProducto.tokenConfig != undefined ? this.datosEmpresaProducto.datosProducto.tokenConfig : this.datosEmpresaProducto.datosProducto.surveyToken;
    let datos={
      productoId: refDatos.idProducto,
      empresaId: refDatos.idEmpresa,
      fecha: fechaElegida,
      token: token != undefined ? token : 'undefined'
    };

    let datos2={
      productoId: refDatos.idProducto,
      empresaId: refDatos.idEmpresa,
      fecha: fechaElegida
    }
    console.log("datos1:",datos);
    console.log("datos2:",datos2);

    this.surveyServ.saveProrroga(datos).subscribe((result:any)=>{
      console.log("servicio1:",result);
      if(result.success){
        this.surveyServ.actualizarFechadeCierre(datos2).subscribe((dataresult:any)=>{
          console.log("servicio2:",dataresult);
        });
        let successText = this.translateSrv.instant('AVANCES.SUCCESS-PRORROGA');
        let okText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.OK');
        Swal.fire({
          icon: 'success',
          title: successText,
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          // cancelButtonColor: '#d33',
          confirmButtonText: okText,
        });
        this.actualizarProrroga.emit(refDatos.idProducto);
      }
    });
  }

  cerrarEncuesta(){
    this.cierreApertura_paso2(2);
  }
  abrirEncuesta(){
    this.cierreApertura_paso2(1);
  }
  cierreApertura_paso2(status:number){
    let refDatos = this.datosEmpresaProducto;
    let warningText = this.translateSrv.instant('AVANCES.WARNING-CIERRE-ENCUESTA');
    let successText = this.translateSrv.instant('AVANCES.SUCCESS-CIERRE');
    let aceptarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ACEPTAR');
    let cancelarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.CANCELAR');
    let okText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.OK');
    Swal.fire({
      title: warningText,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: aceptarText,
      cancelButtonText: cancelarText
    }).then((result) => {
      if (result.value) {
        // datos.token=this.token;
        let datos:any = { status };
        this.modalGuardado(4);
        this.surveyServ.actualizaEstatusCierreEncuesta(refDatos.idEmpresa, refDatos.idProducto, datos).subscribe((resul: any) => {
          Swal.fire({
            icon: 'success',
            title: successText,
            showCancelButton: false,
            reverseButtons: true,
            confirmButtonColor: '#3085d6',
            // cancelButtonColor: '#d33',
            confirmButtonText: okText,
          });
          this.actualizarStatusEncuesta.emit(true);
        });
      }
    });
  }

  auditoriaManual(){
    this.modalGuardado(6);
    this.surveyServ.getInfoAudManual().subscribe((respuesta:any) => {
      console.log("getInfoAudManual:",respuesta);
      if(respuesta.success){
        this.infoAudManual = respuesta.result;
      }
    });
    setTimeout(() => {
      const dialogRef = this.dialog.open(ModalComponentAcciones, {
        width: '50%',
        disableClose: true,
        data: {
          tipo: 'auditoriaManual',
          info: JSON.parse(JSON.stringify(this.infoAudManual))
        }
      });
      console.log("infoAudManual:",this.infoAudManual);
      dialogRef.afterClosed().subscribe(result => {
        console.log("resultado:",result);
        if(result != undefined){
          if(!_.isEqual(this.infoAudManual, result)){
            console.log("es diferente");
            this.infoAudManual = result;
            let datosInfoManual = {
              productoId: this.datosEmpresaProducto.idProducto,
              manualAudit_status : result.ManualAudit_Status,
              manualAudit_result : result.ManualAudit_Result,
              manualAudit_text : result.ManualAudit_Text,
              manualAudit_auditorName : result.ManualAudit_AuditorName
            };
            this.surveyServ.setInfoAudManual(datosInfoManual).subscribe((respuesta:any) => {
              console.log("setInfoAudManual:",respuesta);
            });
            //reinicia la master table
            this.datosMasterTable = [];
          } else{
            console.log("es igual, no hay cambios");

          }
        }
      });

    }, 3000);

  }

  cierreManual(){
    let text = this.translateSrv.instant('ACCIONES.MODALES.CONFIR_REPRO_RESULT');
    let aceptarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ACEPTAR');
    let siText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.RESP_SI');
    let noText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.RESP_NO');
    let okText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.OK');
    let cancelarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.CANCELAR');
    Swal.fire({
      title: text,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: siText,
      cancelButtonText: noText
    }).then((result) => {
      if (result.value) {


      let textPart1 = this.translateSrv.instant('ACCIONES.MODALES.MOD_INGRE_COD_PT1');
      let textPart2 = this.translateSrv.instant('ACCIONES.MODALES.MOD_INGRE_COD_PT2');
        let r = Math.random().toString(36).substring(7);
        console.log("cadena de datos aleatorios: ",r);
        let codigo=r;
        Swal.fire({
          title: textPart1+'<font color="red">'+codigo+'</font>'+textPart2,
          icon: 'info',
          input:'text',
          showCancelButton: true,
reverseButtons: true,


          cancelButtonText: cancelarText,
          confirmButtonText: aceptarText
        })
        .then( (borrar) => {
          console.log(borrar);
          if (borrar.value==codigo) {
            this.modalGuardado(2);
            let refDatos = this.datosEmpresaProducto;
            let datos = {
              empresaId: refDatos.idEmpresa,
              productoId: refDatos.idProducto,
            };
            console.log('si coincide y tendria que jalar ',datos);

            this.surveyServ.cierreManual(datos).subscribe((respuesta:any) => {
              console.log("cierreManual:",respuesta);
              if(respuesta.success){
                Swal.fire({
                  title: this.translateSrv.instant('AVANCES.PROCESAR.OK'),
                  icon: "success",
                  confirmButtonColor: '#e40601'
                });
               Swal.close();
              } else{
                Swal.fire({
                  title: this.translateSrv.instant('AVANCES.PROCESAR.NOTOK'),
                  icon: "warning",
                  confirmButtonColor: '#e40601'
                });
                Swal.close();
              }
            });
          }
          else{
            if(!borrar.dismiss){
              Swal.fire({
              icon: 'error',
              title:  this.translateSrv.instant('ACCIONES.MODALES.ERROR_CODIGO'),
              showConfirmButton: true,

              confirmButtonText: okText
              })
            }

          }
        });

      }
    });

  }

  bloquearResultados(){
    const datosBotLockResu: any = this.datosBoton('lockRes');
    let textoPregunta: string;
    let textoRazon: string;
    if(datosBotLockResu.switch == true){
      textoPregunta = this.translateSrv.instant('ACCIONES.MODALES.BLOQUEAR_1_1');
      textoRazon = this.translateSrv.instant('ACCIONES.MODALES.BLOQUEAR_1_2');
    } else{
      textoPregunta = this.translateSrv.instant('ACCIONES.MODALES.BLOQUEAR_2_1');
      textoRazon = this.translateSrv.instant('ACCIONES.MODALES.BLOQUEAR_2_2');
    }

    Swal.fire({
      title: textoPregunta,
      icon: 'warning',
      allowOutsideClick: false,
      reverseButtons: true,
      showCancelButton: true,
      confirmButtonText: this.translateSrv.instant('AVANCES.BOTONES-MODALES.ACEPTAR'),
      cancelButtonText: this.translateSrv.instant('AVANCES.BOTONES-MODALES.CANCELAR')
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: textoRazon,
          icon: 'info',
          input: 'textarea',
          allowOutsideClick: false,
          width: '40%',
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonText: this.translateSrv.instant('AVANCES.BOTONES-MODALES.ACEPTAR'),
          cancelButtonText: this.translateSrv.instant('AVANCES.BOTONES-MODALES.CANCELAR'),
          inputValidator: (value) => {
            if (!value) {
              return this.translateSrv.instant('ACCIONES.MODALES.BLOQUEAR_3_1')
            }
          }
        })
        .then( (razonCambio) => {
          if(razonCambio.isConfirmed){
            // Swal.fire('no pasó nada :v')
            let token = this.datosEmpresaProducto.datosProducto.tokenConfig != undefined ? this.datosEmpresaProducto.datosProducto.tokenConfig : this.datosEmpresaProducto.datosProducto.surveyToken;
            let datos = {
              surveyToken: token,
              status: datosBotLockResu.switch == true ? 1 : 0,
              reason: razonCambio.value
            };
            console.log("datosEnviarBloqueo:",datos);
            this.surveyServ.setBloqueoResultados(datos).subscribe((respuesta:any) => {
              console.log("setBloqueoResultados:",respuesta);
              this.openSuccessSnackBar(this.translateSrv.instant('ACCIONES.MODALES.SUCC_UPDA_NAME'),'');
            });
          } else if(razonCambio.isDismissed){
            datosBotLockResu.switch = !datosBotLockResu.switch;
          }
        });

      } else{
        datosBotLockResu.switch = !datosBotLockResu.switch;
      }
    });
  }

  verResultIframe(){
    if (this.gralResultActivo) {
      console.log('entro ifrmae');
      let datos={
        status:true,
        tipoIframe:'resul',
      }
      this.verResultadosIframe.emit(datos);
      this.modalGuardado(1);
    }else{
      Swal.fire({
        title: this.translateSrv.instant('MODALES.MENSAJES.NO_RESU_ACTI'),
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText:  this.translateSrv.instant('MODALES.MENSAJES.OK'),
      });

    }

  }

  verWCPIframe(){
    console.log('entro ifrmae Web Company Profile');
    let datos={
      status:true,
      tipoIframe:'wpc',
    }
    this.verResultadosIframe.emit(datos);
    this.modalGuardado(1);
  }

  setTipoResu(accion:string, subAccion:string){
    let refDatos = this.datosEmpresaProducto;
    const dialogRef = this.dialog.open(ModalComponentAcciones, {
      width: '50%',
      disableClose: true,
      data: {
        tipo: 'tipoResultados',
        accion, subAccion,
        versionSuccesGo: this.versionSuccesGo
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("resultado:",result);
      if(result != undefined){
        this.versionSuccesGo = result;
        let datos = { versionSuccesGo: result };
        this.surveyServ.setVersionSGO(refDatos.idEmpresa, refDatos.idProducto, datos).subscribe((respuesta:any) => { console.log("setVersionSGO:",respuesta); });
      }
    });
  }

  versionResultV2(){
    if (this.gralResultActivo) {
      console.log('entro ifrmae');
      let datos={
        status:true,
        tipoIframe:'resulV2',
      }
      this.verResultadosIframe.emit(datos);
      this.modalGuardado(1);
    }else{
      Swal.fire({
        title: this.translateSrv.instant('MODALES.MENSAJES.NO_RESU_ACTI'),
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText:  this.translateSrv.instant('MODALES.MENSAJES.OK'),
      });

    }
  }

  selectIdiomaCertificado(){
    let text = this.translateSrv.instant('ACCIONES.MODALES.CONFIR_REG_CERT');
    let aceptarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ACEPTAR');
    let cancelarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.CANCELAR');
    Swal.fire({
      title: text,
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: aceptarText,
      cancelButtonText: cancelarText
    }).then((result) => {
      if (result.value) {
        let refDatos = this.datosEmpresaProducto;
        const dialogRef = this.dialog.open(ModalComponentAcciones, {
          width: '30%',
          disableClose: true,
          data: {
            tipo: 'selectIdiomaCertificado',
            // accion, subAccion,
            // versionSuccesGo: this.versionSuccesGo
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log("resultado:",result);
          if(result != undefined){
            this.regenerarCertifi(result);
          }
        });
      }
    });
}

  verRecordatorios(accion:string, subAccion:string){
    console.log('this.datosEmpresaProducto',this.datosEmpresaProducto);

    let refDatos = this.datosEmpresaProducto;
    const dialogRef = this.dialog.open(ModalComponentAcciones, {
      width: '50%',
      // disableClose: true,
      data: {
        tipo: 'verRecordatorios',
        recordatorios: this.datosEmpresaProducto,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("resultado:",result);
      this.actualizarRecordatorios.emit(true);
    });
  }

  verAvisos(accion:string, subAccion:string){
    console.log();

    let refDatos = this.datosEmpresaProducto;
    const dialogRef = this.dialog.open(ModalComponentAcciones, {
      width: '50%',
      // disableClose: true,
      data: {
        tipo: 'verAvisos',
        datosAvisos: this.datosEmpresaProducto,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("resultado:",result);
      this.actualizarAvisos.emit(true);
    });
  }

  verFechIniCie(accion:string, subAccion:string){
    console.log();

    let refDatos = this.datosEmpresaProducto;
    const dialogRef = this.dialog.open(ModalComponentAcciones, {
      width: '50%',
      disableClose: true,
      data: {
        tipo: 'verFechIniCie',
        datosDateStartEnd: this.datosEmpresaProducto,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("resultado:",result);
      this.actualizarFechIniCie.emit(true);
    });
  }

  updNameIcon(){
    let text = this.translateSrv.instant('ACCIONES.MODALES.CONFIR_UPDA_NAM');
    let aceptarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ACEPTAR');
    let cancelarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.CANCELAR');
    Swal.fire({
      title: text,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: aceptarText,
      cancelButtonText: cancelarText
    }).then((result) => {
      if (result.value) {
        this.modalGuardado(2);
        this.surveyServ.updateNameIconEmpresa(this.datosEmpresaProducto.idEmpresa,this.datosEmpresaProducto.idProducto).subscribe((respuesta:any) => {
          console.log("updateNameIconEmpresa:",respuesta);
          if (respuesta.success==true) {
            this.openSuccessSnackBar(this.translateSrv.instant('ACCIONES.MODALES.SUCC_UPDA_NAME'),'');
            Swal.close();
          }
        });
      }
    });

  }

  cambiaLogoEmpresa_paso1(){
    let el: HTMLElement = this.logoEmpresa.nativeElement;
    el.click();
  }
  cambiaLogoEmpresa_paso2(event: Event) {
    // this.cropped = null!;
    console.log("event:",event);
    let configEspecial = {
      width: 250,
      height: 250,
      type: 'image/png',
      fill: 'white',
      keepAspectRatio: true,
      // responsiveArea: true,
      output: {
        height: 200,
        width: 200
      },
      extraZoomOut: true,
      // resizableArea: true
    };
    this._dialog.open<ModalImgComponent, any>(ModalImgComponent, {
      data: {event, configEspecial},
      disableClose: true
    // }).afterClosed.subscribe((result?: ImgCropperEvent, objDrop?: any) => {
    }).afterClosed.subscribe((result?: any) => {
      let [resultado,objDrop] = result;
      if (resultado) {
        // Swal.fire({
        //   title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.GUARDANDO_LOGO'),
        //   allowOutsideClick: false,
        //   didOpen: () => {
        //     Swal.showLoading()
        //   }
        // });
          this.modalGuardado(7);
        // this.cropped[`${pagina}_${paso}_${elemento}`] = resultado.dataURL;
        this._cd.markForCheck();
        console.log("resultado:",resultado);
        console.log("objDrop:",objDrop);
        let nomSplit = objDrop.name.split(".");
        fetch(resultado.dataURL)
          .then(res => res.blob()) // Gets the response and returns it as a blob
          .then(blob => {
            console.log("blob:",blob);
            let nombreArchivo: string = `${Date.now()}.${nomSplit[nomSplit.length - 1]}`;
            let file = new File([blob], nombreArchivo, {type: objDrop.type});
            console.log("file:",file);
            this.cambiaLogoEmpresa_paso3(file);
        });
      }
    });
  }
  cambiaLogoEmpresa_paso3(archivo:any){
    let objInstituto = this.brokerConfig.logoCertificado.find(item => item.broker == parseInt(localStorage.getItem('instituto_id')));
    if(objInstituto != undefined){
      if(objInstituto.productos.includes(localStorage.getItem('tipoProducto')) ){
        this.cambiaLogoEmpresa_paso4_empresa(archivo);
      } else{
        this.cambiaLogoEmpresa_paso4_empresa(archivo, true);
      }
    } else{
      this.cambiaLogoEmpresa_paso4_empresa(archivo, true);
    }

  }
  cambiaLogoEmpresa_paso4_empresa(file:any, vistaPrevia?:boolean){
    let fd = new FormData();
    fd.append('file', file, file.name);
    this.surveyServ.saveLogoEmpresa(fd).subscribe((data: any) => {
      if (data.message == "700") {
        let url = DATOS_API.urlLogos.split(":");
        this.rutaLogoEmpresa = url[1] + "/surveyadministrator/backend/" + data.rutaArchivo;
        if(vistaPrevia){
          Swal.close();
          this.previewLogoEmp();
        } else{
          if(this.versionCloudNueva == true){
            this.cambiaLogoEmpresa_paso4_encuesta_cloudNuevo(file);
          } else{
            this.cambiaLogoEmpresa_paso4_encuesta_cloudAnterior(file);
          }
        }
      }
    });
  }
  cambiaLogoEmpresa_paso4_encuesta_cloudAnterior(archivo:any){
    let carpetaBroker = this.carpetaImagenes;
    let ubicacion = `${carpetaBroker.ubicacion}${carpetaBroker.nombre}/`;
    const reader: FileReader = new FileReader();
    let fd = new FormData();
    fd.append('file',archivo, archivo.name);
    fd.append('ubicacion',ubicacion);
    fd.append('carpetaId',carpetaBroker._id);
    this.cloudService.guardaArchivo(fd).subscribe((res) => {
        if(res.status){
          if(res.status == "progress"){
            // this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          console.log("cargaOk:",res);
          let url = DATOS_API.urlLogos.split(":");
          let htp = DATOS_API.urlLogos.split("/");
          let urlFileManager = DATOS_API.urlFileManager;
          let urlImagenCargada = htp[0] + url[1] + urlFileManager + res.archivo.ubicacion.substr(2) + res.archivo.nombre;
          this.jsonLogos.logos.company.image = urlImagenCargada;
          this.jsonLogos.logos.company.set = true;
          Swal.close();
          this.previewLogoEmp(true);
          // this.getImagenesCarpeta();
          // this.copiarURL(urlImagenCargada);
        }
        else{
          if(res.message == 'archivo_save_1'){
            // this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
          }
        }
      },
      (err) => console.log(err)
    );
  }
  cambiaLogoEmpresa_paso4_encuesta_cloudNuevo(archivo:any){
    let carpetaBroker = this.carpetaImagenes;
    let ubicacion = `${carpetaBroker.path}`;
    const reader: FileReader = new FileReader();
    let fd = new FormData();
    fd.append('File',archivo, archivo.name);
    fd.append('path',ubicacion);
    fd.append('mkdir','false');
    fd.append('copyifexists','false');
    fd.append('overwrite','false');
    this.cloudService.guardaArchivo_nuevo(fd).subscribe((res) => {
        if(res.status){
          if(res.status == "progress"){
            // this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          console.log("cargaOk:",res);
          let urlFileServer = DATOS_API.endpoints.cloud.getArchivo;
          let urlImagenCargada = urlFileServer + ubicacion + '/' + res.response.Success;
          this.jsonLogos.logos.company.image = urlImagenCargada;
          this.jsonLogos.logos.company.set = true;
          Swal.close();
          this.previewLogoEmp(true);
          // this.getImagenesCarpeta();
          // this.copiarURL(urlImagenCargada);
        }
        else{
          if(res.message == 'archivo_save_1'){
            // this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
          }
        }
      },
      (err) => console.log(err)
    );
  }
  previewLogoEmp(actualizarJson?:boolean){
    Swal.fire({
      // title: this.translateSrv.instant('EDITOR.ELEMENTOS.GUIA'),
      // html: '<img src="https://www.harley-davidson.com/content/dam/h-d/images/product-images/bikes/motorcycle/2021/2021-sport-glide/2021-sport-glide-f16/2021-sport-glide-f16-motorcycle.jpg" alt="" width="100%">',
      html: `<img src="${this.rutaLogoEmpresa}" alt="" width="200" style="border:1px solid grey!important"><br><br><em>${this.translateSrv.instant('SHEDULE2_0.CARDS.PASO7.LOGO_EMP_INFO')}</em>`,

      confirmButtonText: 'OK',
    });
    if(actualizarJson){
      this.surveyServ.updateJsonLogos(this.jsonLogos._id, { logos: this.jsonLogos.logos }).subscribe((respuesta:any) => {
        console.log('updateJsonLogos:',respuesta);
      });
    }
  }

  regenerarCertifi(lang){
    console.log('tokenConfig',this.datosEmpresaProducto.datosProducto.tokenConfig);
    console.log('tokenConfig',this.datosEmpresaProducto.datosProducto.surveyToken);
    let token="";
    if (this.datosEmpresaProducto.datosProducto.tokenConfig) {
      console.log('entro con tokenConfig');

      token=this.datosEmpresaProducto.datosProducto.tokenConfig
    }else{
      console.log('entro con surveyToken');

      token=this.datosEmpresaProducto.datosProducto.surveyToken;
    }

        let datos={
          surveyToken:token,
          lang:lang,
        }
        console.log('datos',datos);

        this.modalGuardado(2);
        this.surveyServ.regenerateCerti(datos).subscribe((respuesta:any) => {
          console.log("regenerateCerti:",respuesta);
          if (respuesta.out_ResultCode==1) {
            this.openSuccessSnackBar(this.translateSrv.instant('ACCIONES.MODALES.SUCC_UPDA_NAME'),'');
            Swal.close();
          }else{
            Swal.close();
            Swal.fire({
              // title: this.translateSrv.instant('ACCIONES.MODALES.WARNI_NOT_EXIT_TOKEN'),
              title: respuesta.out_ResultMsg,
              icon: "warning",
              confirmButtonColor: '#e40601'
            });
          }
        });


  }

  revisaResolucionImagen(evt){
    const target: DataTransfer = <DataTransfer>(evt.target);
    const reader: FileReader = new FileReader();
    // const archivo = evt.target.files[0];

    reader.onload = (XD) => {
      var img = new Image;

      // img.onload = (x) => {
      //   const reso = {
      //     width: x.naturalWidth,
      //     height: x.naturalHeight
      //   };
      //   console.log ("resolucion imagen: " + reso);
      // };
      img.onload = function() {
        console.log("The width of the image is " + img.width + "px.");
      };
      // img.src = window.URL.createObjectURL( XD );
      // img.src = reader.result;
    };
    reader.readAsDataURL(target.files[0]);



    // const reader: FileReader = new FileReader();
    // // const archivo = evt.files[0];
    // reader.onload = function (e) {
    //   var img = new Image;
    //   img.onload = function() {
    //     console.log("The width of the image is " + img.width + "px.");
    //   };
    //   // img.src = reader.result;
    // };
    // reader.readAsDataURL(evt.target.files[0]);
  }
  cambiaLogoCert_paso1(){
    let el: HTMLElement = this.logoCertificado.nativeElement;
    el.click();
    // this.logoCertificado.click();
  }
  cambiaLogoCert_paso2(event: any) {
    // this.cropped = null!;
    console.log("event:",event);
    // this.revisaResolucionImagen(event);
    let configEspecial = {
      width: 350,
      height: 210,
      minWidth: 400,
      // type: 'image/png',
      fill: 'white',
      keepAspectRatio: true,
      // responsiveArea: true,
      output: {
        height: 240,
        width: 400
      },
      extraZoomOut: true,
      // resizableArea: true
    };
    //imagen original
    let logoOrig = event.target.files[0];
    console.log("logoOrig:",logoOrig);

    this._dialog.open<ModalImgComponent, any>(ModalImgComponent, {
      data: {event, configEspecial, mensaje: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CARGA_CERT')},
      disableClose: true,
      width: "700px"
    // }).afterClosed.subscribe((result?: ImgCropperEvent, objDrop?: any) => {
    }).afterClosed.subscribe((result?: any) => {
      let [resultado,objDrop] = result;
      if (resultado) {
        // Swal.fire({
        //   title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.GUARDANDO_LOGO'),
        //   allowOutsideClick: false,
        //   didOpen: () => {
        //     Swal.showLoading()
        //   }
        // });
        this.modalGuardado(7);
        // this.cropped[`${pagina}_${paso}_${elemento}`] = resultado.dataURL;
        this._cd.markForCheck();
        console.log("resultado:",resultado);
        console.log("objDrop:",objDrop);
        let nomSplit = objDrop.name.split(".");
        fetch(resultado.dataURL)
          .then(res => res.blob()) // Gets the response and returns it as a blob
          .then(blob => {
            console.log("blob:",blob);
            let nombreArchivo: string = `${Date.now()}.${nomSplit[nomSplit.length - 1]}`;
            let file = new File([blob], nombreArchivo, {type: objDrop.type});
            console.log("file:",file);
            if(this.versionCloudNueva == true){
              this.cambiaLogoCert_paso3_cloudNuevo(file);
            } else{
              this.cambiaLogoCert_paso3_cloudAnterior(file);
            }
        });
        if(this.versionCloudNueva == true){
          this.cambiaLogoCert_paso3_cloudNuevo(logoOrig, true);
        } else{
          this.cambiaLogoCert_paso3_cloudAnterior(logoOrig, true);
        }
      }
    });
  }
  cambiaLogoCert_paso3_cloudAnterior(archivo:any, original?:boolean){
    let carpetaBroker = this.carpetaImagenes;
    let ubicacion = `${carpetaBroker.ubicacion}${carpetaBroker.nombre}/`;
    const reader: FileReader = new FileReader();
    let fd = new FormData();
    fd.append('file',archivo, archivo.name);
    fd.append('ubicacion',ubicacion);
    fd.append('carpetaId',carpetaBroker._id);
    // fd.append('ubicacion',this.direccionRaiz);
    // fd.append('empresaId',this.idEmpresa);
    // console.log(...fd);
    // new Response(fd).text().then(console.log);
    this.cloudService.guardaArchivo(fd).subscribe((res) => {
        if(res.status){
          if(res.status == "progress"){
            // this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          console.log("cargaOk:",res);
          let url = DATOS_API.urlLogos.split(":");
          let htp = DATOS_API.urlLogos.split("/");
          let urlFileManager = DATOS_API.urlFileManager;
          let urlImagenCargada = htp[0] + url[1] + urlFileManager + res.archivo.ubicacion.substr(2) + res.archivo.nombre;
          if(original == undefined){
            this.jsonLogos.logos.certificate.image = urlImagenCargada;
            this.jsonLogos.logos.certificate.set = true;
          } else{
            this.jsonLogos.logos.original.image = urlImagenCargada;
            this.jsonLogos.logos.original.set = true;
          }
          this.cambiaLogoCert_paso4(original);
          Swal.close();
          // this.getImagenesCarpeta();
          // this.copiarURL(urlImagenCargada);
        }
        else{
          if(res.message == 'archivo_save_1'){
            // this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
          }
        }
      },
      (err) => console.log(err)
    );
  }
  cambiaLogoCert_paso3_cloudNuevo(archivo:any, original?:boolean){
    let carpetaBroker = this.carpetaImagenes;
    let ubicacion = `${carpetaBroker.path}`;
    const reader: FileReader = new FileReader();
    let fd = new FormData();
    fd.append('File',archivo, archivo.name);
    fd.append('path',ubicacion);
    fd.append('mkdir','false');
    fd.append('copyifexists','false');
    fd.append('overwrite','false');
    this.cloudService.guardaArchivo_nuevo(fd).subscribe((res) => {
        if(res.status){
          if(res.status == "progress"){
            // this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          console.log("cargaOk:",res);
          let urlFileServer = DATOS_API.endpoints.cloud.getArchivo;
          let urlImagenCargada = urlFileServer + ubicacion + '/' + res.response.Success;
          if(original == undefined){
            this.jsonLogos.logos.certificate.image = urlImagenCargada;
            this.jsonLogos.logos.certificate.set = true;
          } else{
            this.jsonLogos.logos.original.image = urlImagenCargada;
            this.jsonLogos.logos.original.set = true;
          }
          this.cambiaLogoCert_paso4(original);
          Swal.close();
          // this.getImagenesCarpeta();
          // this.copiarURL(urlImagenCargada);
        }
        else{
          if(res.message == 'archivo_save_1'){
            // this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
          }
        }
      },
      (err) => console.log(err)
    );
  }
  cambiaLogoCert_paso4(original?:boolean){
    this.surveyServ.updateJsonLogos(this.jsonLogos._id, { logos: this.jsonLogos.logos }).subscribe((respuesta:any) => {
      console.log('updateJsonLogos:',respuesta);
      let instituto = parseInt(localStorage.getItem('instituto_id'));
      this.setLogoCertEditable(instituto);
      if(original == undefined){
        this.previewCert();
      }
    });
  }
  previewCert(){
    const dialogRef = this.dialog.open(ModalRecoComponent, {
      width: '40%',
      data: {
        opcion: 'certificado',
        imagen: this.jsonLogos.logos.certificate.image,
        nombreEmpresa: this.nombreEmpresa
      }
    });
  }

  verCloud(){
    console.log("this.versionCloudNueva:",this.versionCloudNueva);
    console.log("this.datosBanderas.fileServer_v2:",this.datosBanderas.fileServer_v2);


    let ruta = this.versionCloudNueva == false && this.datosBanderas.fileServer_v2 == true ? 'file-server-private' : 'file-manager';
    // this.router.navigate(['/companies/detail',this.datosEmpresaProducto.idEmpresa,this.datosEmpresaProducto.idProducto,'file-manager']);
    this.router.navigate(['/companies/detail', this.datosEmpresaProducto.idEmpresa, this.datosEmpresaProducto.idProducto, ruta]);
  }
  verCloudPublico(){
    console.log("this.versionCloudNueva:",this.versionCloudNueva);
    console.log("this.datosBanderas.fileServer_v2:",this.datosBanderas.fileServer_v2);
    if(this.versionCloudNueva == true){
      this.router.navigate(['/file-manager',this.datosEmpresaProducto.idEmpresa,this.datosEmpresaProducto.idProducto]);
    } else{
      if(this.datosBanderas.fileServer_v2 == true){
        this.router.navigate(['/companies/detail', this.datosEmpresaProducto.idEmpresa, this.datosEmpresaProducto.idProducto, 'file-server']);
      } else{
        this.router.navigate(['/file-manager',this.datosEmpresaProducto.idEmpresa,this.datosEmpresaProducto.idProducto]);
      }
    }
  }

  activaMultiSite(){
    console.log("valorActual:",this.datosBoton('regCertifi','multiSite'));
    const datosMultiSite: any = this.datosBoton('regCertifi','multiSite');
    this.datosBanderas.certification_key = datosMultiSite.switch;
    if(datosMultiSite.switch == true){
      this.activarBoton('regCertifi', true, null, 'multiSiteText');
    } else{
      this.activarBoton('regCertifi', false, null, 'multiSiteText');
    }
    this.surveyServ.setFlagsConfig(this.datosBanderas, this.datosEmpresaProducto.idEmpresa, this.datosEmpresaProducto.idProducto).subscribe((respuesta:any) => {
      console.log("setFlagsConfig:",respuesta);
      if(respuesta.success){
        this.openSuccessSnackBar(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.SAVED_CHANGES'),'');
      }
    });
    //
    //
  }

  async cambiaTextoMultiSite(){
    const { value: textoCertificado } = await Swal.fire({
      title: this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.TITULO'),
      input: 'textarea',
      inputLabel: this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.SUBTITULO2'),
      inputPlaceholder: this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.HINT'),
      showCancelButton: true,
      allowOutsideClick: false,
      width: '40%',
      confirmButtonText: this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.OK'),
      cancelButtonText: this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.CANCEL'),
      reverseButtons: true,
      inputValue: this.textoCertificado
    })

    if (textoCertificado) {
      // Swal.fire(textoCertificado)
      const datos = {
        productoId: this.datosEmpresaProducto.idProducto,
        certification_key_text: textoCertificado
      };
      this.surveyServ.actualizaTextoCertificado(this.datosEmpresaProducto.idEmpresa, datos).subscribe((respuesta:any) => {
        console.log("actualizaTextoCertificado:",respuesta);
        this.textoCertificado = textoCertificado;
        this.openSuccessSnackBar(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.SAVED_CHANGES'),'');
      });
    }
  }

  libeCultureBrief(){
      let text = this.translateSrv.instant('ACCIONES.MODALES.CONFIR_LIBE_CULT_BRI');
      let aceptarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ACEPTAR');
      let siText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.RESP_SI');
      let noText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.RESP_NO');
      let okText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.OK');
      let cancelarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.CANCELAR');
      Swal.fire({
        title: text,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: siText,
        cancelButtonText: noText
      }).then((result) => {
        if (result.value) {
        let textPart1 = this.translateSrv.instant('ACCIONES.MODALES.MOD_INGRE_COD_PT1');
        let textPart2 = this.translateSrv.instant('ACCIONES.MODALES.MOD_INGRE_COD_PT2');
          let r = Math.random().toString(36).substring(7);
          console.log("cadena de datos aleatorios: ",r);
          let codigo=r;
          Swal.fire({
            title: textPart1+'<font color="red">'+codigo+'</font>'+textPart2,
            icon: 'info',
            input:'text',
            showCancelButton: true,
            reverseButtons: true,
            cancelButtonText: cancelarText,
            confirmButtonText: aceptarText
          })
          .then( (borrar) => {
            console.log(borrar);
            if (borrar.value==codigo) {
              this.modalGuardado(2);
              let data={
                productoId:this.datosEmpresaProducto.idProducto,
              }
              console.log('si coincide y tendria que jalar ',data);
              this.surveyServ.postliberaciónCultureBrief(data).subscribe((respuesta:any) => {
                console.log("postliberaciónCultureBrief:",respuesta);
                if (respuesta.success) {
                  if (respuesta.message=='associatedNotFound') {
                     Swal.close();
                    Swal.fire({
                      title: this.translateSrv.instant('ACCIONES.MODALES.NO_CULT_BRI_ASOC'),
                      icon: "warning",
                      confirmButtonColor: '#e40601'
                    });
                  }else if(respuesta.message=="200"){
                    this.openSuccessSnackBar(this.translateSrv.instant('ACCIONES.MODALES.SUCC_UPDA_NAME'),'');
                     Swal.close();
                  }
                }

              });


            }
            else{
              if(!borrar.dismiss){
                Swal.fire({
                icon: 'error',
                title:  this.translateSrv.instant('ACCIONES.MODALES.ERROR_CODIGO'),
                showConfirmButton: true,

                confirmButtonText: okText
                })
              }

            }
          });

        }
      });
  }

  cambiaCultureBrief(){
    const dialogRef = this.dialog.open(ModalComponentAcciones, {
      width: '50%',
      disableClose: true,
      data: {
        tipo: 'cambiaCultureBrief'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("resultado:",result);
    });
  }

  verCultureAudit(){
    window.open(this.linkCultureAudit, '_blank');
  }

  modalGuardado(tipo:number){
    let mensaje: string;
    switch (tipo) {
      case 1: //Cargando resultados
      this.translateSrv.get('ACCIONES.MODALES.CHANGE_RESULT').subscribe((res: string) => { mensaje = res; });
      break;
      case 2://Actualizando
      this.translateSrv.get('ACCIONES.MODALES.UPDA_NAME_ICON').subscribe((res: string) => { mensaje = res; });
      break;
      case 3://Sincronizando portal de conteos
      this.translateSrv.get('AVANCES.SINCRONIZACION.SINCRONIZANDO').subscribe((res: string) => { mensaje = res; });
      break;
      case 4://Actualizar estatus encuesta
      this.translateSrv.get('ACCIONES.MODALES.UPDA_STA_ENC').subscribe((res: string) => { mensaje = res; });
      break;
      case 5: //MasterTable
      this.translateSrv.get('ACCIONES.MODALES.LOADINGMASTER').subscribe((res: string) => { mensaje = res; });
      break;
      case 6: //Auditoria
      this.translateSrv.get('ACCIONES.MODALES.OBT_DAT_AUD_AUT').subscribe((res: string) => { mensaje = res; });
      break;
      case 7: //Cambio logo certificado
      this.translateSrv.get('SHEDULE2_0.MODALES.ENCUESTA.GUARDANDO_LOGO').subscribe((res: string) => { mensaje = res; });
      break;
      case 8: //enviando correos
      this.translateSrv.get('HISTORIAL_MAILS.MODALES.SEND_EMA').subscribe((res: string) => { mensaje = res; });
      break;
      case 9: //Creando clave wcp externo
      this.translateSrv.get('ACCIONES.MODALES.CRE_ACCE_WCP_EXT').subscribe((res: string) => { mensaje = res; });
      break;
      case 10: //Actualizando Información
      this.translateSrv.get('ACCIONES.MODALES.ACTU_ACCE_WCP_EXT').subscribe((res: string) => { mensaje = res; });
      break;
      default:
      break;
    }
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      showConfirmButton: false,
      imageUrl: localStorage.getItem('urlGifBroker'),
      imageWidth: 100,
      imageHeight: 60,
    });
  }

  openSuccessSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 4000,
      panelClass: ['background-success']
    });
  }

  getTiposCorreos(){
    this.surveyServ.getTiposCorreos(this.datosEmpresaProducto.idProducto).subscribe((respuesta:any) => {
      // console.log("getTiposCorreos:",respuesta);
      if(respuesta.success){
        this.tiposCorreos = respuesta.tipos;
      }
    });
  }
  enviaCorreos(){
    const dialogRef = this.dialog.open(ModalComponentLogMail, {
      width: '50%',
      disableClose: true,
      data: {
        tiposCorreos: this.tiposCorreos
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("resultado:",result);
      if(result != undefined){
        let datos = {
          empresaId: localStorage.getItem('companyID'),
          productoId: this.datosEmpresaProducto.idProducto,
          tipo: result
        };
        this.modalGuardado(8);
        console.log("datos:",datos);
        this.surveyServ.enviarCorreos(datos).subscribe((respuesta:any) => {
          console.log("enviarCorreos:",respuesta);
          if(respuesta.success){
            Swal.fire({
              title: this.translateSrv.instant('HISTORIAL_MAILS.MODALES.ENVIADOS'),
              icon: 'info',
              confirmButtonText: 'OK',
              confirmButtonColor: '#e40601'
            })
            Swal.close();
            this.openSuccessSnackBar(this.translateSrv.instant('HISTORIAL_MAILS.MODALES.SUCC_SEND_EMA'),'');
          }
        });


      }
    });
  }

  cancelarEnvios(){
    if(this.enviosCancelables == true){
      Swal.fire({
        title: this.translateSrv.instant("ACCIONES.MODALES.CANCELAR_ENVIOS"),
        icon: 'question',
        allowOutsideClick: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: this.translateSrv.instant('AVANCES.BOTONES-MODALES.ACEPTAR'),
        cancelButtonText: this.translateSrv.instant('AVANCES.BOTONES-MODALES.CANCELAR')
      }).then((result) => {
        if(result.isConfirmed){
          const datos = { productoId: localStorage.getItem('productoID') };
          this.surveyServ.cancelarEnvios(datos).subscribe((respuesta:any) => {
            console.log("cancelarEnvios:",respuesta);
            if(respuesta.success == true){
              this.openSuccessSnackBar(this.translateSrv.instant("ACCIONES.MODALES.CANCELAR_ENVIOS_OK"),'');
            }
          });
        }
      });
    } else{
      Swal.fire({
        title: this.translateSrv.instant("ACCIONES.MODALES.CANCELAR_ENVIOS_ERROR"),
        icon: 'warning',
        allowOutsideClick: false,
        reverseButtons: true,
        showCancelButton: false,
        confirmButtonText: this.translateSrv.instant('AVANCES.BOTONES-MODALES.ACEPTAR')
      });
    }
  }

    getStatusPublicWebComProfile(){
      this.wcp.getStatusWebComProfile(this.datosEmpresaProducto.idProducto).subscribe( (respuestaStatus:any) => {
        console.log('respuestaStatus',respuestaStatus);
        if(respuestaStatus.success == true){
          let datosSwitchwpc: any = this.datosBoton('verWebComPro','updateStatusWCP');
          console.log("datosSwitchwpc:",datosSwitchwpc);
          datosSwitchwpc.switch = respuestaStatus.data.outWCPVisibility;
        }
      });
    }


    // updateStatusVisibilityWCP(){
    //   const datosSwitchwpc: any = this.datosBoton('verWebComPro','updateStatusWCP');
    //   if (!datosSwitchwpc.switch) {
    //     console.log('El valor es False ');
    // const dialogRef = this.dialog.open(ModalCompProfileComponent,
    //   {
    //   width: '50%',
    //   height: '40%',
    //   data: {
    //     productoId:this.datosEmpresaProducto.idProducto,
    //     status:datosSwitchwpc.switch,
    //     tipo:'NoStatusVisi'
    //   }
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   this.getStatusPublicWebComProfile();
    // });
    //
    // }else{
    // console.log('El valor es true ');
    //
    //   let datos={
    //     productoId:this.datosEmpresaProducto.idProducto,
    //     visibility:datosSwitchwpc.switch,
    //     reason:" "
    //   }
    //   this.wcp.updateStatusNoPublicWebComProfile(datos).subscribe( (respuestaUpdaStatus:any) => {
    //     console.log('respuestaUpdaStatus',respuestaUpdaStatus);
    //     if(respuestaUpdaStatus.success == true){
    //       this.getStatusPublicWebComProfile();
    //     }
    //   });
    //
    // }
    //
    // }

    updateStatusVisibilityWCP(){
       const datosSwitchwpc: any = this.datosBoton('verWebComPro','updateStatusWCP');
      console.log('event', datosSwitchwpc.switch);
      if (!datosSwitchwpc.switch) {
    const dialogRef = this.dialog.open(ModalCompProfileComponent,
      {
      width: '50%',
      height: '40%',
      data: {
        productoId:this.datosEmpresaProducto.idProducto,
        status:datosSwitchwpc.switch,
        tipo:'NoStatusVisi'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('result',result);
      if (!result.cambio) {
        // this.statusWCP=!this.statusWCP;
      }
      this.getStatusPublicWebComProfile();
    });
    }else{
    const dialogRef = this.dialog.open(ModalCompProfileComponent,
        {
        width: '30%',
        height: '80%',
        data: {
          productoId:this.datosEmpresaProducto.idProducto,
          status:datosSwitchwpc.switch,
          tipo:'StatusVisi'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('result',result);
        if (!result.cambio) {
          // this.statusWCP=!this.statusWCP;
        }
        this.getStatusPublicWebComProfile();
      });

    }

    }


    resultFuncionando(){
      // console.log('la mando a llamar ');

      this.surveyServ.getFlagSuccesGo().subscribe((respuesta:any) => {
        // console.log('respuesta',respuesta);
        this.gralResultActivo = respuesta.flagStatus;

      })
    }



    permitirDescargarDemo(){
      console.log('la mando a llamar permitirDescargarDemo');
      //
      // this.surveyServ.getFlagSuccesGo().subscribe((respuesta:any) => {
      //   console.log('respuesta',respuesta);
      //   this.gralResultActivo = respuesta.flagStatus;
      //
      // })
    }


    verConfigResult(){
      localStorage.setItem('instituto_correos',localStorage.getItem('instituto_id'))
      let datos
      const dialogRef = this.dialog.open(ConfigResultComponent, {
        width: '85%',
        height: '85%',
        data: {
          empresaId: this.datosEmpresaProducto.idEmpresa,
          productoId: this.datosEmpresaProducto.idProducto,
          tokenConfig:  this.datosEmpresaProducto.datosProducto.tokenConfig,
          tipo:'confResult',
          infoProducto:this.datosEmpresaProducto.datosProducto,
          instituto:localStorage.getItem('instituto_id'),
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }

    getInfoAccesoWPC(){
      this.surveyServ.getdataWPC(this.datosEmpresaProducto.idEmpresa).subscribe((respuesta:any) => {
        console.log('respuesta',respuesta);

        let datosSwitchWCP: any;
        if (respuesta.urlExternalWCP=="") {
          this.activarBoton('crearClave',false,true);
          this.activarBoton('verDatWPC',true,false);
        }else{
          this.getdataWPCPassword=respuesta.password;
          this.getdataWPCPEnlace=respuesta.urlExternalWCP;
          this.activarBoton('crearClave',true,false);
          this.activarBoton('verDatWPC',false,true);
          this.activarBoton('verDatWPC', true, null, 'visibleSwitchWCP');
          datosSwitchWCP= this.datosBoton('verDatWPC','visibleSwitchWCP');
          console.log("datosSwitchWCP:",datosSwitchWCP);
          datosSwitchWCP.switch = respuesta.visibleWCP;
        }

        // this.gralResultActivo = respuesta.flagStatus;

      })
    }

    crearClaveWcp(){
      Swal.fire({
        title: this.translateSrv.instant('ACCIONES.MODALES.COM_CRE_ACCE_WCP_EXT'),
        icon: 'warning',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: this.translateSrv.instant('AVANCES.BOTONES-MODALES.ACEPTAR'),
        cancelButtonText: this.translateSrv.instant('AVANCES.BOTONES-MODALES.CANCELAR'),
      }).then((result) => {
        if (result.value) {
            let r = Math.random().toString(16).substring(7);
          // datos.token=this.token;
          let datos:any = {
            urlExternalWCP:`${DATOS_API.urlWcpExterno}${this.datosEmpresaProducto.idEmpresa}`,
            visibleWCP: true,
            password: '$'+r+'%',
          };
          console.log('Datos a enviar ',datos);

          this.modalGuardado(9);
          this.surveyServ.updateDataWPC(this.datosEmpresaProducto.idEmpresa,datos).subscribe((resul: any) => {
            console.log('resul',resul);
            if (resul.success) {
              Swal.close();
              this.openSuccessSnackBar(this.translateSrv.instant('ACCIONES.MODALES.SUCC_CRE_ACCE_WCP_EXT'),'');
              this.getInfoAccesoWPC();
            }
          });
        }
      });
    }

    // CopyClaveWcp(){
    //   console.log('this.getdataWPCPassword',this.getdataWPCPassword);
    //   const selBox = document.createElement('textarea');
    //   selBox.style.position = 'fixed';
    //   selBox.style.left = '0';
    //   selBox.style.top = '0';
    //   selBox.style.opacity = '0';
    //   selBox.value =  `${this.getdataWPCPassword}`;
    //   document.body.appendChild(selBox);
    //   selBox.focus();
    //   selBox.select();
    //   document.execCommand('copy');
    //   document.body.removeChild(selBox);
    //   Swal.fire({
    //     icon: 'success',
    //     title: this.translateSrv.instant('ACCIONES.MODALES.URL'),
    //
    //     confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
    //   });
    // }

    CopyClaveWcp(){
      const dialogRef = this.dialog.open(ModalCompProfileComponent,
        {
          width: '30%',
          disableClose: true,
        data: {
          WPCPassword:this.getdataWPCPassword,
          WPCPEnlace:this.getdataWPCPEnlace,
          tipo:'infoAcce'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('result',result);
        if (!result.cambio) {
        }
      });
    }

    visibleSwitchWCP(){
      // const datosMultiSite: any = this.datosBoton('crearClave','visibleSwitchWCP');
      const datosWCP: any = this.datosBoton('verDatWPC','visibleSwitchWCP');
      let datos:any = {
        visibleWCP: datosWCP.switch,
      };
      this.modalGuardado(10);
      this.surveyServ.updateDataWPC(this.datosEmpresaProducto.idEmpresa,datos).subscribe((resul: any) => {
        console.log('resul',resul);
        if (resul.success) {
          Swal.close();
          this.openSuccessSnackBar(this.translateSrv.instant('ACCIONES.MODALES.SUCC_ACTU_ACCE_ACCE_WCP_EXT'),'');
          this.getInfoAccesoWPC();
        }
      });

    }

    getMarkCulturAudit(){
        this.surveyServ.getMarkCultureAudit(this.datosEmpresaProducto.idEmpresa,this.datosEmpresaProducto.idProducto).subscribe((resul: any) => {
        console.log('resul',resul);
        if(resul.success){
          const datosBotMarkCulturAudit: any = this.datosBoton('confirReviCultureAudit');
          resul.result.output.AuthStatus == 1 ? datosBotMarkCulturAudit.switch = true : false;
        }
      });

    }

  confirReviCultureAudit(){
    const datosBotMarkCulturAudit: any = this.datosBoton('confirReviCultureAudit');
    console.log('datosBotMarkCulturAudit',datosBotMarkCulturAudit.switch);
    let text = '';
    datosBotMarkCulturAudit.switch == true ? text=this.translateSrv.instant('ACCIONES.MODALES.CONFIR_REVI_CULT_AUDIT') : text=text=this.translateSrv.instant('ACCIONES.MODALES.NO_CONFIR_REVI_CULT_AUDIT');
    // Confirmar revicion de cultural audit
    // let text = this.translateSrv.instant('ACCIONES.MODALES.CONFIR_LIBE_CULT_BRI');
    let aceptarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ACEPTAR');
    let siText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.RESP_SI');
    let noText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.RESP_NO');
    let okText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.OK');
    let cancelarText = this.translateSrv.instant('AVANCES.BOTONES-MODALES.CANCELAR');
    Swal.fire({
      title: text,
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: siText,
      cancelButtonText: noText
    }).then((result) => {
      console.log(result);

      if (result.value) {
      let textPart1 = this.translateSrv.instant('ACCIONES.MODALES.MOD_INGRE_COD_PT1');
      let textPart2 = this.translateSrv.instant('ACCIONES.MODALES.MOD_INGRE_COD_PT2');
        let r = Math.random().toString(36).substring(7);
        console.log("cadena de datos aleatorios: ",r);
        let codigo=r;
        Swal.fire({
          title: textPart1+'<font color="red">'+codigo+'</font>'+textPart2,
          icon: 'info',
          input:'text',
          showCancelButton: true,
          reverseButtons: true,
          cancelButtonText: cancelarText,
          confirmButtonText: aceptarText
        })
        .then( (borrar) => {
          console.log(borrar);
          if (borrar.value==codigo) {
            this.modalGuardado(2);
            let data={
              productoId:this.datosEmpresaProducto.idProducto,
              markId:datosBotMarkCulturAudit.switch == true ?  1: 2,
            }
            console.log('si coincide y tendria que jalar ',data);
            this.surveyServ.postMarkCultureAudit(this.datosEmpresaProducto.idEmpresa,data).subscribe((respuesta:any) => {
              console.log("postliberaciónCultureBrief:",respuesta);
              if (respuesta.success) {
                if (respuesta.message=='associatedNotFound') {
                   Swal.close();
                  Swal.fire({
                    title: this.translateSrv.instant('ACCIONES.MODALES.NO_CULT_BRI_ASOC'),
                    icon: "warning",
                    confirmButtonColor: '#e40601'
                  });
                }else if(respuesta.message=="200"){
                  this.openSuccessSnackBar(this.translateSrv.instant('ACCIONES.MODALES.SUCC_UPDA_NAME'),'');
                   Swal.close();
                }
              }

            });


          }
          else{
            if(!borrar.dismiss){
              Swal.fire({
              icon: 'error',
              title:  this.translateSrv.instant('ACCIONES.MODALES.ERROR_CODIGO'),
              showConfirmButton: true,

              confirmButtonText: okText
              })
              datosBotMarkCulturAudit.switch=!datosBotMarkCulturAudit.switch;
            }
            if(borrar.isConfirmed==false){
              datosBotMarkCulturAudit.switch=!datosBotMarkCulturAudit.switch;
            }

          }
        });

      }else{
        datosBotMarkCulturAudit.switch=!datosBotMarkCulturAudit.switch;
      }
    });
  }


}
